import React from 'react';
import { ChapterContextType } from './types';

const ChapterContext = React.createContext<ChapterContextType | undefined>(
  undefined,
);

export default ChapterContext;
